import { hasYesOrNo } from 'models/validate';
import { ValidateJSModel } from 'forms/shared/types';
import foreignBusinessFamilyItemValidator from './validators/item';
import { ForeignBusinessFamilyModel } from './types';

const foreignBusinessFamilyValidator: ValidateJSModel<ForeignBusinessFamilyModel> = {
  HasForeignFamily: { hasValue: { validator: hasYesOrNo } },

  List: (value, attributes) => {
    if (attributes?.HasForeignFamily?.value === 'Yes') {
      return {
        presence: true,
        accordion: { validator: foreignBusinessFamilyItemValidator },
      };
    }

    return {};
  },
};

export default foreignBusinessFamilyValidator;
